if (!customElements.get('character-list-with-details')) {
  customElements.define(
    'character-list-with-details',
    class CharacterListWithDetails extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          iconCards: '.col-char-card',
          colDetails: '.col-details__inner',
          dialog: '.char-dialog'
        };
      }

      connectedCallback() {
        // If no blocks, do nothing
        if (this.dataset.hoverable !== 'true') return;

        // Feature-detect mobile: prefer FoxTheme flag if present
        this.isMobile = (window.FoxTheme?.config?.mqlMobile) ??
          window.matchMedia('(max-width: 1023px)').matches;

        this.iconCards = this.querySelectorAll(this.selectors.iconCards);
        this.dialog = this.querySelector(this.selectors.dialog);
        this.colDetails = this.querySelector(this.selectors.colDetails);
        this.selectedIndex = 0;
        this.hoverTimer = null;

        if (!this.isMobile && this.colDetails) {
          // Desktop hover -> swap details
          this.iconCards.forEach(card => {
            card.addEventListener('mouseenter', (e) => this.onHover(e));
          });
          this.colDetails.addEventListener('mouseenter', () => clearTimeout(this.hoverTimer));
        } else {
          // Mobile tap -> dialog
          this.iconCards.forEach(card => {
            card.addEventListener('click', () => this.openDialogFromCard(card));
          });

          // Close by clicking ✕ or backdrop
          this.dialog?.addEventListener('click', (e) => {
            if (e.target === this.dialog || e.target.closest('.char-dialog__close')) {
              this.closeDialog();
            }
          });

          // ESC to close
          this.dialog?.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeDialog();
          });
        }
      }

      // DESKTOP
      onHover(evt) {
        const card = evt.currentTarget;
        const index = card.dataset.index;
        clearTimeout(this.hoverTimer);

        this.hoverTimer = setTimeout(() => {
          if (this.selectedIndex != index) {
            this.selectedIndex = index;
            this.showDetails(index);
          }
        }, 200);
      }

      showDetails(index) {
        const all = this.colDetails.querySelectorAll('.clwd-char');
        all.forEach(el => el.classList.remove('active'));

        let toShow = this.colDetails.querySelector(`.clwd-char[data-index="${index}"]`);
        if (!toShow) {
          const tpl = this.colDetails.querySelector(`template[data-index="${index}"]`);
          if (tpl) {
            const frag = tpl.content.cloneNode(true);
            toShow = frag.querySelector('.clwd-char');
            this.colDetails.appendChild(toShow);
          }
        }
        toShow?.classList.add('active');
      }

      // MOBILE
      openDialogFromCard(card) {
        const tplSel = card.dataset.dialogTemplate;
        const tpl = tplSel ? document.querySelector(tplSel) : null;
        if (!tpl || !this.dialog) return;

        // inject template content
        this.dialog.innerHTML = '';
        this.dialog.appendChild(tpl.content.cloneNode(true));

        // open
        try {
          this.dialog.removeAttribute('inert');
          this.dialog.showModal?.();
        } catch (_) {
          // Fallback if <dialog> not supported: emulate
          this.dialog.setAttribute('open', '');
        }

        // focus close button for a11y
        const btn = this.dialog.querySelector('.char-dialog__close');
        btn?.focus();
      }

      closeDialog() {
        if (!this.dialog) return;
        try {
          this.dialog.close?.();
        } catch (_) {
          this.dialog.removeAttribute('open');
        }
        this.dialog.setAttribute('inert', '');
      }
    }
  );
}
